import * as React from 'react';
import { AuthCard } from 'ts/components/Card';
import { Heading } from 'ts/components/Heading';
import { Button } from '@origin-digital/style-guide';
import { InfoText } from 'ts/components/InfoText';
import { Page } from '../../../../components/Page';

interface CallCentreRegisterThankyouViewProps {
  nextAction: () => void;
}

const CallCentreRegisterThankyouView: React.FC<CallCentreRegisterThankyouViewProps> = ({
  nextAction,
}) => (
  <Page>
    <AuthCard>
      <>
        <Heading text="Your account is active" />
        <InfoText text="You can log in to My Account right away with your email and password." />
        <Button text="Log in" block={true} onClick={nextAction} />
      </>
    </AuthCard>
  </Page>
);

export { CallCentreRegisterThankyouView };
